// External Imports
import get from 'lodash/fp/get';
import { compile } from 'path-to-regexp';
import { createSelector } from 'reselect';

// Internal Imports
import { SEARCH_ARCHIVE } from '../config/types/path.js';
import { getActivePagination } from './getActivePagination.js';
import { getMatch } from './getMatch.js';
import { getPathMap } from './getPathMap.js';
import { getRouteKey } from './index.js';

// Local Functions
const getSearchPath = createSelector([getPathMap, getMatch], (pathMap, { params }) => {
  const searchToPath = compile(pathMap[SEARCH_ARCHIVE]);
  const languageEdition = params.language === 'en-US' ? 'en' : params.language;
  return searchToPath({
    ...params,
    language: languageEdition,
    page: 1,
  });
});

const getSearchParameters = createSelector([getMatch], (match) => ({
  s: '',
  ...match.query,
}));

const getSearchResultsShowing = createSelector(
  [get('archive'), getRouteKey, getActivePagination],
  (archiveState, routeKey, { currentPage, perPage }) => {
    const pages = get([routeKey, 'pages'], archiveState);
    const pageNumbers = Object.keys(pages);

    if (pageNumbers.length > 0 && pages[currentPage]) {
      const firstItemPosition = (currentPage - 1) * perPage + 1;
      return [firstItemPosition, firstItemPosition + (pages[currentPage].length - 1)];
    }

    return [];
  },
);

// Module Exports
export { getSearchParameters, getSearchPath, getSearchResultsShowing };
